import { defineStore } from 'pinia';

import { getDomain, MoneyFormatter } from '@libs/utils';

export const useGlobalCurrencyStore = defineStore('GlobalCurrencyStore', () => {
  // Helpers
  function formatMoney(amount: number): string {
    return MoneyFormatter.instance.formatWithCurrency(
      amount,

      getDomain.getCurrentDomainSpec().Currency,
      getDomain.getCurrentDomainSpec().FullLocale
    );
  }
  return {
    // Helpers
    formatMoney,
  };
});
